import { useCallback } from 'react'
import type { PreferenciasGerais } from '@dv/contracts'
import { usePreferencias } from './shell/contexto-de-preferencias.tsx'

export type Idioma = PreferenciasGerais['idioma']
export type Traducao = Readonly<Record<Idioma, string>>

/** Catálogos explícitos de interface; dados da API e nomes próprios não são traduzidos. */
export function useTextos<Chave extends string>(catalogo: Readonly<Record<Chave, Traducao>>) {
  const { idioma } = usePreferencias()
  return useCallback((chave: Chave): string => catalogo[chave][idioma], [catalogo, idioma])
}
